import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

import About from '../components/about'

const AboutPage = () => <About />

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/about.js